// Local history for the Compare Theses modal — last 5 ticker pairs.
//
// Round 95al (Jun 2026). Mirrors the regular Compare Stocks modal
// pattern (pair-only, no snapshot persistence). When a user re-opens
// a recent pair we let the backend's 24h cache decide whether the
// LLM brief is still fresh — anything older than 24h triggers a
// fresh Gemini call on both sides.

const STORAGE_KEY = 'dividrip.compareThesesHistory.v1';
const MAX_PAIRS = 5;

function readRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (p) => p && typeof p === 'object' && typeof p.a === 'string' && typeof p.b === 'string'
    );
  } catch {
    return [];
  }
}

function writeRaw(pairs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pairs.slice(0, MAX_PAIRS)));
  } catch {
    // ignore (quota / private mode)
  }
}

// Normalise tickers — always uppercase + trim. Pair key is the
// alpha-sorted joined tuple so (KO, PEP) and (PEP, KO) dedupe to one
// entry, but we keep the original display order so the user sees what
// they actually opened.
function pairKey(a, b) {
  return [String(a).toUpperCase().trim(), String(b).toUpperCase().trim()].sort().join('|');
}

export function getRecentPairs() {
  return readRaw();
}

export function rememberPair(a, b, meta = null) {
  const A = String(a || '').toUpperCase().trim();
  const B = String(b || '').toUpperCase().trim();
  if (!A || !B || A === B) return readRaw();
  const key = pairKey(A, B);
  const prior = readRaw();
  const existing = prior.find((p) => pairKey(p.a, p.b) === key);
  const rest = prior.filter((p) => pairKey(p.a, p.b) !== key);
  // Carry forward any verdict/score we already had unless this call
  // supplies a fresh `meta` payload (post-fetch upgrade path).
  const nextEntry = {
    a: A,
    b: B,
    ts: Date.now(),
    verdictA: meta?.verdictA ?? existing?.verdictA ?? null,
    verdictB: meta?.verdictB ?? existing?.verdictB ?? null,
    scoreA: meta?.scoreA ?? existing?.scoreA ?? null,
    scoreB: meta?.scoreB ?? existing?.scoreB ?? null,
  };
  const next = [nextEntry, ...rest].slice(0, MAX_PAIRS);
  writeRaw(next);
  return next;
}

export function clearRecentPairs() {
  writeRaw([]);
  return [];
}
